import { CompanyInfo as Content, RdPathLoader } from '@neo.tax/rd/organisms';
import { Path } from '@neo.tax/shared';

import { useCompanyInfoRedirect } from './hooks';

export const CompanyInfo = (): React.ReactElement => (
  <RdPathLoader path={Path.COMPANY_INFO} useRedirect={useCompanyInfoRedirect}>
    <Content />
  </RdPathLoader>
);
